import {InitialStateProps} from "@/app";

/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function (initialState: InitialStateProps) {
  const { flatMenus = {}, routePathCodeMap = {} } = initialState || {};

  return {
    haveButton: (pathname: string, code: string) => {
      let normalizedPathname = normalizePath(pathname);
      const routeCode = routePathCodeMap[normalizedPathname];
      // console.log("normalizedPathname", normalizedPathname, routeCode, routePathCodeMap, flatMenus);
      if (!routeCode) return false;
      return !!flatMenus[`${routeCode}.${code}`];
    },
  };
}

function normalizePath(path: string) {
  if (!path) return path;
  // 去掉末尾多余的 /
  return path.replace(/\/+$/, '') || '/';
}
